import React from 'react';

const HeroSection: React.FC = () => {
  return (
    <div className="hero-section">
      <div className="hero-description">
        <p>
          <span className="highlight">BLOOT</span>: Create custom BLOOT BOXES with localized jackpots.
        </p>
        <p>
          Design your <span className="highlight-text">BLOOT BOX</span>. Set <span className="highlight-text">odds</span>. Build a <span className="highlight-text">jackpot</span>. Earn <span className="highlight-text">fees</span> on every play.
        </p>
      </div>
    </div>
  );
};

export default HeroSection;
